export enum OrderSide {
  BUY = 'buy',
  SELL = 'sell'
}

export enum OrderStatus {
  CLOSED = 'closed',
  OPEN = 'open',
  CANCELLED = 'cancelled',
  REJECTED = 'rejected',
  NEW = 'new'
}

export enum FillStatus {
  FILLED = 'filled',
  PARRTIALLY_FILLED = 'partially_filled',
  UNFILLED = 'unfilled'
}

export enum OrderType {
  Market = 'market',
  Limit = 'limit',
  StopLimit = 'stop-limit',
  StopMarket = 'stop-market'
}
